{
  "common.error_generic": "Algo salió mal. Inténtalo de nuevo más tarde."
}
